import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_pqhb98yzxr: FaireBrandEntity = {
  token: "b_pqhb98yzxr",
  type: "brand",
  name: "Mi Esperanza Minerals",
  avatarUrl:
    "https://cdn.faire.com/fastly/1760691cca8ec60ed269574a9130795db99502b1cc79688490143822de93e47f.webp",
  bannerUrl:
    "https://cdn.faire.com/fastly/296333693805d25079536f7fe904283d887df9276a0b48fa619b2c7f36eaa01f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1760691cca8ec60ed269574a9130795db99502b1cc79688490143822de93e47f.webp",
  heroImageUrl:
    "https://cdn.faire.com/fastly/296333693805d25079536f7fe904283d887df9276a0b48fa619b2c7f36eaa01f.jpeg",
  location: "El Paso, TX, USA",
  minimumOrderDollars: 139,
  rating: 4.9,
  reviewCount: 109,
  isTopShop: true,
  isInsider: true,
  description:
    "*** We usually have 100s of Onyx bowls and lamps in stock that are not yet uploaded online, please send us a message if you wish to do a video call***\n\nWelcome to Mi Esperanza Minerals, a trusted crystal and mineral wholesale shop.\nMi Esperanza Minerals is a woman/minority owned company and is located in El Paso, Texas.\nWe directly source high quality Onyx and Marble products from Mexico as well as other minerals from all over the world. \n",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:41.699Z",
    importedBy: "entity-db-cli",
  },
};
